"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRetrievable = exports.reupload = void 0;
const cafe_utility_1 = require("cafe-utility");
const http_1 = require("../utils/http");
const typed_bytes_1 = require("../utils/typed-bytes");
const stewardshipEndpoint = 'stewardship';
/**
 * Reupload locally pinned data
 * @param requestOptions Options for making requests
 * @param reference
 * @throws BeeResponseError if not locally pinned or invalid data
 */
async function reupload(requestOptions, stamp, reference) {
    await (0, http_1.http)(requestOptions, {
        method: 'put',
        url: `${stewardshipEndpoint}/${reference}`,
        headers: { 'swarm-postage-batch-id': stamp.toHex() },
    });
}
exports.reupload = reupload;
async function isRetrievable(requestOptions, reference) {
    reference = new typed_bytes_1.Reference(reference);
    const response = await (0, http_1.http)(requestOptions, {
        method: 'get',
        responseType: 'json',
        url: `${stewardshipEndpoint}/${reference}`,
    });
    const body = cafe_utility_1.Types.asObject(response.data, { name: 'response.data' });
    return cafe_utility_1.Types.asBoolean(body.isRetrievable, { name: 'isRetrievable' });
}
exports.isRetrievable = isRetrievable;
